import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class DocumentService {
  baseUrl = 'document';

  getDeletedGrid = (paginationSettings) => BaseService.post({
        url: `${this.baseUrl}/get-deleted-grid`,
        data: paginationSettings
    });

  removeDeleted = (ids) => BaseService.post({ url: `${this.baseUrl}/remove-deleted`, data: ids });
  restoreDeleted = (ids) => BaseService.post({ url: `${this.baseUrl}/restore-deleted`, data: ids });

  getLockedGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-locked-grid`);
  unlock = (ids) => BaseService.post({ url: `${this.baseUrl}/unlock`, data: ids });

  canDisplay = (id) => BaseService.get({ url: `${this.baseUrl}/can-display/${id}` });
  canAddDataToInternalTables = (contentTypeId) => BaseService.get({ url: `${this.baseUrl}/can-add-data-internal-tables/${contentTypeId}` });
  download = (id, lockDocument) => Utils.file.attachment.download(`${this.baseUrl}/download/${id}/${lockDocument}`);
  downloadSelected = (ids) => Utils.file.attachment.download(`${this.baseUrl}/download-selected`, {
    method: 'POST', // or 'PUT'
    body: JSON.stringify(ids),
    headers: {
      'Content-Type': 'application/json'
    }
  });

  print = (id) => Utils.file.attachment.print(`${this.baseUrl}/print/${id}`);
  display = (id) => Utils.file.attachment.get(`${this.baseUrl}/display/${id}`);
  getVersionList = (id) => BaseService.get({ url: `${this.baseUrl}/get-version-list/${id}` });
  getHistoryList = (id) => BaseService.get({ url: `${this.baseUrl}/get-history-list/${id}` });

  // Distribution
  getDistributionList = (id) => BaseService.get({ url: `${this.baseUrl}/get-distribution-list/${id}` });
  getDistributedEmails = () => BaseService.get({ url: `${this.baseUrl}/get-distributed-emails` });
  deleteDistributedEmail = (email) => BaseService.post({ url: `${this.baseUrl}/delete-distributed-email`, data: email });
  getUsersForDistributionList = (ids) => BaseService.post({ url: `${this.baseUrl}/get-users-for-distribution`, data: ids });
  findEmailsInDocumentsContent = (ids) => BaseService.post({ url: `${this.baseUrl}/find-emails-in-content`, data: ids });
  distribute = (distribution) => BaseService.post({ url: `${this.baseUrl}/distribute`, data: distribution });
  confirmReception = (id) => BaseService.post({ url: `${this.baseUrl}/confirm-reception/${id}` });
  canSignExternal = () => BaseService.get({ url: `${this.baseUrl}/can-sign-external` });

  // Validate/Refuse
  getAvailableFlows = (transitionType, ids) => BaseService.post({ url: `${this.baseUrl}/get-available-flows/${transitionType}`, data: ids });
  validate = (documents) => BaseService.post({ url: `${this.baseUrl}/validate`, data: documents });
  getFlowDiagrams = (id) => BaseService.get({ url: `${this.baseUrl}/get-flow-diagrams/${id}` });

  getSupportedFileFormats = () => BaseService.get({ url: `${this.baseUrl}/get-supported-file-formats` });

  displayTempPdf(id, fileExtension, source = null) {
    let url = `${this.baseUrl}/display-temp-pdf/${id}/${fileExtension}`;
    if (source !== null) {
        url += `/${source}`;
    }
    return Utils.file.attachment.get(url);
  }

  deleteTempPdf = (id) => BaseService.post({ url: `${this.baseUrl}/delete-temp-pdf/${id}` });
  get = (id) => BaseService.get({ url: `${this.baseUrl}/get/${id}` });
  getStructure = (contentTypeId) => BaseService.get({ url: `${this.baseUrl}/get-structure/${contentTypeId}` });
  getStructureWithData = (contentTypeId, fields) => BaseService.post({ url: `${this.baseUrl}/get-structure-with-data/${contentTypeId}`, data: fields });
  getStructureIsoCompliance = (contentTypeId) => BaseService.post({ url: `${this.baseUrl}/get-structure-iso-compliance/${contentTypeId}` });
  removeVersion = (id, deleteAllVersions) => BaseService.post({ url: `${this.baseUrl}/remove-version/${id}/${deleteAllVersions}` });
  remove = (ids) => BaseService.post({ url: `${this.baseUrl}/remove`, data: ids });
  export = (ids) => Utils.file.attachment.download(`${this.baseUrl}/export`, {
    method: 'POST', // or 'PUT'
    body: JSON.stringify(ids),
    headers: {
      'Content-Type': 'application/json'
    }
  });

  save = (document) => BaseService.post({ url: `${this.baseUrl}/save-document`, data: document });
  saveDocumentPendingObject = (documentPendingObject) => BaseService.post({ url: `${this.baseUrl}/save-document-pendingObject`, data: documentPendingObject });

  updateMultiple = (documents, forceUpdateReadonlyFields = null) => {
    let url = `${this.baseUrl}/update-multiple`;

    if (forceUpdateReadonlyFields !== null) {
        url += `?forceUpdateReadonlyFields=${encodeURIComponent(forceUpdateReadonlyFields)}`;
    }
    return BaseService.post({ url: url, data: documents });
    };

  sign = (signData) => BaseService.post({ url: `${this.baseUrl}/sign`, data: signData });
  getSignatureList = (id) => BaseService.get({ url: `${this.baseUrl}/get-signature-list/${id}` });
  sendByEmail = (sendByEmailData) => BaseService.post({ url: `${this.baseUrl}/send-by-email`, data: sendByEmailData });
  uploadScannedAttachment = (file) => BaseService.post({ url: `${this.baseUrl}/upload-scanned-attachment`, data: file });
  updateDocumentFile = (file) => BaseService.post({ url: `${this.baseUrl}/update-document-file`, data: file });
  retrySignature = (id) => BaseService.post({ url: `${this.baseUrl}/retry-signature/${id}` });
}

export default new DocumentService();
